:host{display:block}
/*# sourceMappingURL=flip-groups-graph.component-Y5JO6ER3.css.map */
